module.exports = __webpack_public_path__ + "static/img/Jesse-Ramien.c11d178.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jesse-Ramien.jpg
// module id = Ro+D
// module chunks = 0